import { QueryClient } from "react-query";

/* staleTime berilmaganda react-query'ning sukut qiymati 0 bo'ladi, ya'ni
   keshda ma'lumot turgan bo'lsa ham har komponent mount bo'lganda darhol
   qayta so'rov ketadi. Prod loglarida shu sababli bir kunda 24 000 so'rov
   yig'ilgan: masalan currency 1964, employee/all 1758 marta so'ralgan.

   60 sekund ehtiyotkor qiymat: sahifalar orasida yurganda takroriy so'rov
   ketmaydi, lekin ma'lumot ham eskirib ketmaydi. Mutatsiyadan keyin
   jadval refetch() ni to'g'ridan-to'g'ri chaqiradi va u staleTime'ni
   aylanib o'tadi, shuning uchun saqlash/o'chirishdan keyin ro'yxat
   avvalgidek darhol yangilanadi. */
export const STALE_SHORT = 1000 * 60; // 60 sekund
export const STALE_REFERENCE = 1000 * 60 * 10; // ma'lumotnomalar: 10 daqiqa
export const CACHE_REFERENCE = 1000 * 60 * 15;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: STALE_SHORT,
      cacheTime: 1000 * 60 * 5, // 5 daqiqa (staleTime dan uzun bo'lishi kerak)
      retry: false,
      suspense: true,
    },
  },
});
